export const SET_EXCEL_DATA = "SET_EXCEL_DATA";
export const SET_EXCEL_FORM_DATA = "SET_EXCEL_FORM_DATA";
export const SET_EXCEL_LIST_DATA = "SET_EXCEL_LIST_DATA";


export const SET_REPORT_DATA = "SET_REPORT_DATA";